const archive = document.querySelector('body.blog');

if(archive) {
  const filter = archive.querySelector('.posts-filter');
  const showAllBtn = filter.querySelector('button.show-all');
  const dropdowns = filter.querySelectorAll('.dropdown');
  const filterCategories = filter.querySelector('.filter-categories');
  const filterYear = filter.querySelector('.filter-year');
  const moreBtn = archive.querySelector('button.show-more');
  const featuredPosts = archive.querySelector('.featured-posts');
  let featuredPostsIDs = [];
  if(featuredPosts) {
    featuredPosts.querySelectorAll('.tease').forEach(function(post, index) {
      featuredPostsIDs.push(post.getAttribute('data-id'));
    });
  }
  let category = '';
  let year = '';
  let currentPage = 1;
  let mobile = 'false';
  if(window.innerWidth < 1024) {
    mobile = 'true';
  }

  dropdowns.forEach(function(dropdown, index) {
    dropdown.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      let parent = dropdown.parentNode;
      if(!parent.classList.contains('open')) {
          parent.classList.add('open');
          dropdown.setAttribute('aria-expanded', 'true');
      }
      else {
          parent.classList.remove('open');
          dropdown.setAttribute('aria-expanded', 'false');
      }
      if(window.innerWidth >= 1024) {
        if(!this.parentNode.classList.contains('filter-categories') && filterCategories.classList.contains('open')) {
          filterCategories.classList.remove('open');
        }
        if(!this.parentNode.classList.contains('filter-year') && filterYear.classList.contains('open')) {
          filterYear.classList.remove('open');
        }
      }
    });
  });

  showAllBtn.addEventListener('click', function(e) {
    if(!this.classList.contains('active')) {
      this.classList.add('active');
      if(filterCategories.querySelector('.filter-options li.active')) {
        filterCategories.querySelector('.filter-options li.active').classList.remove('active');
        filterCategories.querySelector('.dropdown span').innerHTML = 'Kategori';
        filterCategories.classList.remove('open');
      }
      if(filterYear.querySelector('.filter-options li.active')) {
        filterYear.querySelector('.filter-options li.active').classList.remove('active');
        filterYear.querySelector('.dropdown span').innerHTML = 'År';
        filterYear.classList.remove('open');
      }
      filter.classList.remove('open');
      category = '';
      year = '';
      getNews();
    }
  });

  filterCategories.querySelectorAll('.filter-options li a').forEach(function(option, index) {
    option.addEventListener('click', function(e) {
      e.preventDefault();
      if(showAllBtn.classList.contains('active')) {
        showAllBtn.classList.remove('active');
      }
      if(filterCategories.querySelector('.filter-options li.active')) {
        filterCategories.querySelector('.filter-options li.active').classList.remove('active');
      }
      if(this.getAttribute('data-slug') != 'all') {
        category = this.getAttribute('data-slug');
        filterCategories.querySelector('.dropdown span').innerHTML = this.innerHTML;
      }
      else {
        category = '';
        filterCategories.querySelector('.dropdown span').innerHTML = 'Kategori';
      }
      this.parentNode.classList.add('active');
      filterCategories.classList.remove('open');
      currentPage = 1;
      getNews();
    });
  });

  filterYear.querySelectorAll('.filter-options li a').forEach(function(option, index) {
    option.addEventListener('click', function(e) {
      e.preventDefault();
      if(showAllBtn.classList.contains('active')) {
        showAllBtn.classList.remove('active');
      }
      if(filterYear.querySelector('.filter-options li.active')) {
        filterYear.querySelector('.filter-options li.active').classList.remove('active');
      }
      if(this.getAttribute('data-slug') != 'all') {
        year = this.getAttribute('data-slug');
        filterYear.querySelector('.dropdown span').innerHTML = this.innerHTML;
      }
      else {
        year = '';
        filterYear.querySelector('.dropdown span').innerHTML = 'År';
      }
      this.parentNode.classList.add('active');
      filterYear.classList.remove('open');
      currentPage = 1;
      getNews();
    });
  });

  if(moreBtn) {
    moreBtn.addEventListener('click', function(e) {
      currentPage++;
      getNews('true');
    });
  }

  function getNews(isShowMore = 'false') {
    let data = new FormData();
    data.append('action', 'get_posts');
    data.append('category', category);
    data.append('year', year);
    data.append('featuredPosts', featuredPostsIDs);
    data.append('currentPage', currentPage);
    data.append('mobile', mobile);
    data.append('show_more', isShowMore);
    if(isShowMore == 'true') {
      archive.querySelector('.loading-spinner.more').classList.add('show');
    }
    else {
      archive.querySelector('.loading-spinner.main').classList.add('show');
      archive.querySelector('.posts-wrapper').innerHTML = '';
      moreBtn.classList.add('hide');
    }

    $.ajax({
        url: heimdal_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        error: function (data) {
            console.error(data);
        },
        complete: function (data) {
          if(isShowMore == 'true') {
            archive.querySelector('.loading-spinner.more').classList.remove('show');
            archive.querySelector('.posts-wrapper >div').innerHTML += data.responseText;
          }
          else {
            archive.querySelector('.loading-spinner.main').classList.remove('show');
            archive.querySelector('.posts-wrapper').innerHTML = data.responseText;
          }
          
          let totalPosts = parseInt(archive.querySelector('.posts-wrapper >div').getAttribute('data-total'));
          let totalShown = archive.querySelectorAll('.posts-wrapper .tease').length;
          if (totalShown < totalPosts) {
              moreBtn.classList.remove('hide');
          }
          else {
              moreBtn.classList.add('hide');
          }
        }
    });
  }
  getNews();
}